export enum CommunityTypes {
  Topic = "Topic",
  Journal = "Journal",
  Council = "Council"
}
